import { useEffect } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { useLanguageContext } from "@/contexts/LanguageContext";
import { AnnouncementBanner } from "@/components/AnnouncementBanner";
import type { Locale } from "@/i18n";

const VALID_LOCALES: Locale[] = ["fr", "ar"];

/**
 * LocaleLayout — lit le paramètre :lang depuis l'URL et synchronise
 * le LanguageContext. Redirige vers /fr si la locale est invalide.
 */
export function LocaleLayout() {
  const { lang } = useParams<{ lang: string }>();
  const { locale, setLocale } = useLanguageContext();

  const isValidLocale = VALID_LOCALES.includes(lang as Locale);

  useEffect(() => {
    if (isValidLocale && lang !== locale) {
      setLocale(lang as Locale);
    }
  }, [lang, locale, setLocale, isValidLocale]);

  if (!isValidLocale) {
    return <Navigate to="/fr" replace />;
  }

  return (
    <>
      <AnnouncementBanner />
      <Outlet />
    </>
  );
}
